import { BehaviorSubject } from 'rxjs/Rx';
import { Utils } from './utils.core';
import { Transfer } from './transfer.core';
import { FileManagerOptions } from '../interface/fileManagerOptions.interface';

// tslint:disable:no-unused-expression

const /** @type {?} */ FileManagerOptionsDefault: FileManagerOptions = {};

const /** @type {?} */ speedObject: any = {
    total: 0,
    loaded: 0,
    percent: 0,
    speed: 0,
    speedToText: '0 bytes'
};
export class FileObject {
    lastModifiedDate: Date | null;
    size: number | null;
    type: string;
    name: string;
/**
 * @param {?} fileOrInput
 */
constructor (fileOrInput: any) {
        let isInput = Utils.isElement(fileOrInput);
        let fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
        let isFakePath = Utils.isString(fakePathOrObject) ?  true : false;
        let method = (v: boolean, x: any) => { if (v) { this._createFromFakePath(x); } else { this._createFromObject(x); } };
        method(isFakePath, fakePathOrObject);
    }
/**
 * @param {?} path
 * @return {?}
 */
private _createFromFakePath (path: string) {
            this.lastModifiedDate = null;
            this.size = null;
            this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
            this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
    }
/**
 * @param {?} object
 * @return {?}
 */
private _createFromObject (object: any) {
            this.lastModifiedDate = new Date(object.lastModifiedDate.getTime());
            this.size = object.size;
            this.type = object.type;
            this.name = object.name;
    }
}

function FileObject_tsickle_Closure_declarations() {
/** @type {?} */
FileObject.prototype.lastModifiedDate;
/** @type {?} */
FileObject.prototype.size;
/** @type {?} */
FileObject.prototype.type;
/** @type {?} */
FileObject.prototype.name;
}

export class FileManager {
public options: FileManagerOptions;
/**
 * @param {?} _protocol
 * @return {?}
 */
public set protocol(_protocol: any) {
        this._protocol = _protocol;
    }
/**
 * @return {?}
 */
public get id(): string {
        return this._id;
    }
/**
 * @return {?}
 */
public get progressPercent$(): any {
        return Utils.asObservable(this._progress$);
    }
/**
 * @return {?}
 */
public get progress$(): any {
        return Utils.asObservable(this._speed$);
    }
/**
 * @return {?}
 */
public get progress(): any {
        return this._progress$.getValue();
    }
/**
 * @return {?}
 */
public get element(): any {
        return this._fileElement;
    }
/**
 * @return {?}
 */
public get object(): FileObject {
        return this._file;
    }
/**
 * @return {?}
 */
public get name(): string {
        return this._file.name;
    }
/**
 * @return {?}
 */
public get type(): string {
        return this._file.type;
    }
/**
 * @return {?}
 */
public get date(): Date | null {
        return this._file.lastModifiedDate;
    }
/**
 * @return {?}
 */
public get size(): number | null  {
        return this._file.size;
    }
/**
 * @return {?}
 */
public get inQueue(): boolean {
        return this._fileActive;
    }
/**
 * @return {?}
 */
public get success(): boolean {
        return this._isSuccess;
    }
/**
 * @return {?}
 */
public get error(): boolean {
        return this._isError;
    }
private _id: string;
private _protocol: any;
private _uploader: Transfer;
private _fileElement: any;
private _file: FileObject;
private _speedDefault: any;
private _progress$: BehaviorSubject<number> = new BehaviorSubject(0);
private _speed$: BehaviorSubject<any> = new BehaviorSubject(speedObject);
private _isUploading: boolean;
private _isUploaded: boolean;
private _isSuccess: boolean;
private _isCancel: boolean;
private _isError: boolean;
private _imageLoad: boolean;
private _fileActive: boolean;
/**
 * Creates an instance of FileManager.
 * 
 * 
 * \@memberOf FileManager
 * @param {?} _file
 * @param {?=} _options
 * @param {?=} _uploader
 */
constructor (_file: any, _options?: FileManagerOptions, _uploader?: Transfer) {
        this.options = Object.assign({}, FileManagerOptionsDefault, _options);
        this._speedDefault = {

        };

        this._id = Utils.uniqueID();

        this._isUploading = false;
        this._isUploaded = false;
        this._isSuccess = false;
        this._isCancel = false;
        this._isError = false;

        let isInput = Utils.isElement(_file);
        let file = isInput ? new FileObject(_file.files[0]) : new FileObject(_file);

        this._file = file;
        this._fileElement = isInput ? _file.files[0] : _file;
        this._fileActive = false;

        if (typeof _uploader !== 'undefined') {
            this.bindUploader(_uploader);
        }
    }
/**
 * Bind uploader to FileManager
 * 
 * 
 * \@memberOf FileManager
 * @param {?} _uploader
 * @return {?}
 */
public bindUploader (_uploader: Transfer): void {
        if (this._uploader instanceof Transfer) {
            this._uploader.removeFile(this);
        }
        this._uploader = _uploader;
        let /** @type {?} */ check = this._uploader.addFile(this);
        this._setFileActive(check);
    }
/**
 * Bind options to FileManager
 * 
 * 
 * \@memberOf FileManager
 * @param {?} _options
 * @return {?}
 */
public bindOptions (_options: FileManagerOptions): void {
        this.options = Object.assign({}, this.options, _options);
    }
/**
 * Return uploader if exists else throw error
 * 
 * 
 * \@memberOf FileManager
 * @return {?}
 */
public getUploader (): Transfer {
        if (this._uploader instanceof Transfer) {
            return this._uploader;
        }
        throw new Error('Not uploader for this file defined.');
    }
/**
 * Start uploading this file
 * 
 * 
 * \@memberOf FileManager
 * @return {?}
 */
public upload (): void {
        let /** @type {?} */ _uploader: Transfer;

        try {
            _uploader = this.getUploader();
        } catch ( /** @type {?} */e) {
            throw new Error('Couldn`t upload because uploader was not defined. ERR_MSG: ' + ( /** @type {?} */((<Error>e))).message);
        }

        this._isUploading = true;

        try {
            _uploader.uploadItem(this);
        } catch ( /** @type {?} */e) {
            // TODO write error handling
        }
    }
/**
 * Cancel upload process from this file
 * 
 * 
 * \@memberOf FileManager
 * @return {?}
 */
public cancel (): void {
        if (this._isUploading) {
            let /** @type {?} */ uploader = this.getUploader();
            uploader.cancelUploadItem(this);
        }
    }
/**
 * @return {?}
 */
public _cancel(): void {
        if (this._isUploading) {
            this._isCancel = true;
            this._isUploaded = false;
            this._isUploading = false;
        }
    }
/**
 * Remove this FileManger from uploader queue
 * 
 * 
 * \@memberOf FileManager
 * @return {?}
 */
public remove (): void {
        let /** @type {?} */ _uploader: any;

        try {
            _uploader = this.getUploader();
        } catch ( /** @type {?} */e) {
            throw new Error('Couldn`t remove because uploader was not defined. ERR_MSG: ' + ( /** @type {?} */((<Error>e))).message);
        }

        (this._isUploading) && this.cancel();

        _uploader.removeFile(this);
        this._setFileActive(false);
    }
/**
 * @return {?}
 */
public isUploaded (): boolean {
        return this._isUploaded;
    }
/**
 * @return {?}
 */
public isUploading (): boolean {
        return this._isUploading;
    }
/**
 * @return {?}
 */
public canUpload(): boolean {
        return (!this._isUploaded && !this._isUploading && !this._isSuccess && !this._isError);
    }
/**
 * @return {?}
 */
public handleImageLoad(): void {
        this._imageLoad = true;
    }
/**
 * Callback
 * @return {?}
 */
onBeforeUpload(): void { return; }
/**
 * @param {?} speed
 * @return {?}
 */
onProgressSpeed(speed: any): void { speed = speed; }
/**
 * Callback
 * @param {?} progress
 * @return {?}
 */
onProgress(progress: number): void { progress = progress; }
/**
 * Callback
 * @param {?} response
 * @param {?} status
 * @param {?} headers
 * @return {?}
 */
onSuccess(response: any, status: number, headers: any): void { response = response; status = status; headers = headers;  }
/**
 * @param {?} response
 * @param {?} status
 * @param {?} headers
 * @return {?}
 */
onError(response: any, status: number, headers: any): void { response = response; status = status; headers = headers;  }
/**
 *  Internal functions
 * @return {?}
 */
_onBeforeUpload(): void {
        this._isUploading = true;
        this._isUploaded = false;
        this._isSuccess = false;
        this._isCancel = false;
        this._isError = false;
        this._progress$.next(0);
        this.onBeforeUpload();
    }
/**
 * @param {?} speed
 * @return {?}
 */
_onProgressFileSpeed (speed: any) {
        this._speed$.next(speed);
        this.onProgressSpeed(speed);
    }
/**
 * @param {?} _progress
 * @return {?}
 */
_onProgress (_progress: number): void {
        this._progress$.next(_progress);
        this.onProgress(_progress);
    }
/**
 * @param {?} response
 * @param {?} status
 * @param {?} headers
 * @return {?}
 */
_onSuccess (response: any, status: number, headers: any): void {
        if (this._uploader.options.removeBySuccess) {
            this.remove();
        }
        this._isUploading = false;
        this._isUploaded = true;
        this._isSuccess = true;
        this._isError = false;
        this.onSuccess(response, status, headers);
    }
/**
 * @param {?} response
 * @param {?} status
 * @param {?} headers
 * @return {?}
 */
_onError (response: any, status: number, headers: any): void {
        this._isUploading = false;
        this._isUploaded = false;
        this._isSuccess = false;
        this._isError = true;
        this.onError(response, status, headers);
    }
/**
 * @param {?} check
 * @return {?}
 */
private _setFileActive(check: boolean): void {
        this._fileActive = check;
    }
}

function FileManager_tsickle_Closure_declarations() {
/** @type {?} */
FileManager.prototype.options;
/** @type {?} */
FileManager.prototype._id;
/** @type {?} */
FileManager.prototype._protocol;
/** @type {?} */
FileManager.prototype._uploader;
/** @type {?} */
FileManager.prototype._fileElement;
/** @type {?} */
FileManager.prototype._file;
/** @type {?} */
FileManager.prototype._speedDefault;
/** @type {?} */
FileManager.prototype._progress$;
/** @type {?} */
FileManager.prototype._speed$;
/** @type {?} */
FileManager.prototype._isUploading;
/** @type {?} */
FileManager.prototype._isUploaded;
/** @type {?} */
FileManager.prototype._isSuccess;
/** @type {?} */
FileManager.prototype._isCancel;
/** @type {?} */
FileManager.prototype._isError;
/** @type {?} */
FileManager.prototype._imageLoad;
/** @type {?} */
FileManager.prototype._fileActive;
}

